import React, { useEffect, useState } from 'react'
import styled from '@emotion/styled'
import { useToggler, useScroller } from '../../hooks'
import { BrowserUtils } from '../../utils/siteUtils'
import { BodyDivFlex } from '../generic/Basics'
import ICOHeader from '../generic/ICOHeader'
import NavFooter from '../generic/navFooter'
import { AftermarketPageNumber, HistoryPageNumber, VehiclePageNumber, ExteriorPageNumber, ImageCapturePageNumber } from '../../constants'
import HistoryComponentWrapper from './HistoryComponentWrapper'
import useEventBus from '../generic/useEventBus'
import { historyQuestionnaire, vehicleIssuesAnswer } from '../../constants/historyQuestionnaire'

export default ({
  experienceState,
  offer,
  prospectDocuments,
  getQuestionResponse,
  getQuestionResponseInteger,
  saveQuestionResponse,
  saveQuestionResponseInteger,
  urlState,
  year,
  make,
  model,
  trim,
  images,
  nextClick,
  backClick,
  addImpressions,
  updateGlobalState,
  variation,
  getHasVehicleModifications,
  vinResults,
  qxData,
  historyVerificationData,
  autoCheckData,
  globalState,
  mileage,
  navigateWithState,
  ...otherProps
}) => {
  const analytics = []
  const { displayImages } = experienceState
  const [setHasScrolled, scroll] = useScroller()
  const [isError, toggleIsError] = useToggler()
  const isDesktop = BrowserUtils.isDesktop()
  const [nextDisabled, setnextDisabled] = useState(false)
  const [showInValidHistoryComponentForm, setShowInValidHistoryComponentForm] = useState(false)

  useEventBus('FormValidated', payload => {
    console.log('FormValidated', { payload })
    if (payload.form === 'vehicle-history-form') {
      setnextDisabled(!payload.isValid)
    }
  })

  useEventBus('QuestionAnsweredInit', event => {
    const { answers } = event
    if (!experienceState?.isAdmin && !answers) return

    const answersList = Object.entries(answers)
    answersList.forEach(([questionId, answer]) => {
      saveHistoryResponse([questionId, answer.value])
    })
  })

  useEventBus('QuestionAnswered', event => {
    const { answered } = event
    if (!experienceState?.isAdmin && !answered) return

    if (answered.section === 'history') {
      const [question] = Object.entries(answered)
      saveHistoryResponse(question)
    }
  })

  const saveHistoryResponse = ([questionId, value]) => {
    const booleanValue = value ? 0 : 1
    urlState = {
      ...urlState,
      [questionId]: { v: questionId === historyQuestionnaire.cleanHistoryReport ? vehicleIssuesAnswer[value] : booleanValue }
    }
    navigateWithState(urlState)
  }

  const errors = []
  const backStep = getHasVehicleModifications() ? AftermarketPageNumber : VehiclePageNumber

  addImpressions(analytics)

  const scrollTarget = isError && errors.length && `#${errors[0].replace(/\//gi, '-')}-error`

  useEffect(() => {
    if (isError && scrollTarget) {
      scroll(scrollTarget)
      setHasScrolled(true)
    } else {
      setHasScrolled(true)
      scroll('body', 'top')
    }
  })

  const backDisabled = nextDisabled && urlState.p !== urlState.lp
  const error = () => {
    setShowInValidHistoryComponentForm(true)
    !isError && toggleIsError()
    setHasScrolled(false)
    updateGlobalState({ fireAnalytics: 'continue_error' })
  }
  const nextStep = urlState && !!urlState.edit ? ExteriorPageNumber : ImageCapturePageNumber

  return (
    <>
      <BodyDivFlex isDesktop={isDesktop}>
        <ICOHeader {...{ displayImages, urlState, year, make, model, images, nextDisabled, errorFunc: error, updateGlobalState, variation, trim, experienceState, globalState, mileage }} />

        <ContentDiv isDesktop={isDesktop}>
          <HistoryComponentWrapper
            showInValidHistoryComponentForm={showInValidHistoryComponentForm}
            contactPageIsLoaded={true}
            {...{
              experienceState,
              offer,
              prospectDocuments,
              getQuestionResponse,
              getQuestionResponseInteger,
              saveQuestionResponse,
              saveQuestionResponseInteger,
              urlState,
              year,
              make,
              model,
              trim,
              images,
              nextClick,
              backClick,
              addImpressions,
              updateGlobalState,
              variation,
              getHasVehicleModifications,
              vinResults,
              qxData,
              historyVerificationData,
              autoCheckData,
              mileage,
              globalState,
              ...otherProps
            }}
          />
        </ContentDiv>
      </BodyDivFlex>
      <NavFooter
        {...{ experienceState, offer, step: HistoryPageNumber, getQuestionResponse, backStep, globalState, nextDisabled, ...otherProps }} //
        backClick={(...e) => (backDisabled ? error() : backClick(...e))}
        nextClick={(...e) => (nextDisabled ? error() : nextClick(nextStep))}
      />
    </>
  )
}

const ContentDiv = styled.div`
  width: ${p => (p.isDesktop ? 80 : 100)}%;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 32px;
  margin-bottom: 64px;
`
